package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

/**
 * Validator for whiteboard data.
 */
object WhiteboardValidator {

    private const val MAX_TEXT_LENGTH = 200

    /**
     * Validates that at least one participant is selected.
     */
    fun validateParticipants(participants: List<String>): Result<Unit> {
        if (participants.isEmpty()) {
            return Result.failure(ValidationError("At least one participant must be selected"))
        }
        return Result.success(Unit)
    }

    /**
     * Validates whiteboard text content.
     */
    fun validateText(text: String): Result<Unit> {
        if (text.isBlank()) {
            return Result.failure(ValidationError("Text cannot be empty"))
        }
        if (text.length > MAX_TEXT_LENGTH) {
            return Result.failure(ValidationError("Text exceeds maximum length of $MAX_TEXT_LENGTH characters"))
        }
        return Result.success(Unit)
    }

    /**
     * Validates whiteboard for creation.
     */
    fun validateForCreation(participants: List<String>): Result<Unit> {
        validateParticipants(participants).onFailure {
            return Result.failure(it)
        }
        return Result.success(Unit)
    }
}
